import { fetchCommonAdminList, type CommonAdminListItem } from "@/services/common";
import type { SelectedUser } from "./types";

export const buildSelectedUserMap = (list: CommonAdminListItem[]) => {
	const result = new Map<number, SelectedUser>();

	const traverse = (items: CommonAdminListItem[]) => {
		items.forEach((item) => {
			item.admin_list.forEach((admin) => {
				result.set(admin.id, {
					id: admin.id,
					realname: admin.realname,
				});
			});

			if (item.children?.length) {
				traverse(item.children);
			}
		});
	};

	traverse(list);

	return result;
};

export const buildSelectedUserList = (list: CommonAdminListItem[]) => {
	return Array.from(buildSelectedUserMap(list).values());
};

export const buildUserSelectTreeData = (list: CommonAdminListItem[]) => {
	const hasDepartmentMembers = (item: CommonAdminListItem): boolean => {
		if (item.admin_list.length > 0) {
			return true;
		}

		if (!item.children?.length) {
			return false;
		}

		return item.children.some((child) => hasDepartmentMembers(child));
	};

	const normalizeTreeData = (items: CommonAdminListItem[]) => {
		return items.map((item) => {
			const memberList = item.admin_list.map((admin) => ({
				title: admin.realname,
				key: `${item.dept_id}-${admin.id}`,
				pid: item.dept_id,
			}));

			const children = item.children ? normalizeTreeData(item.children) : [];

			return {
				title: item.dept_name,
				key: item.dept_id,
				pid: item.pid,
				isEmptyDept: !hasDepartmentMembers(item),
				children: [...children, ...memberList],
			};
		});
	};

	return normalizeTreeData(list);
};

export const fetchSelectedAdminList = async () => {
	const res = await fetchCommonAdminList();

	return res.data ?? [];
};
